import { checkboxClasses } from '@mui/material';
/**
 * Component overrides (i.e. global styles, default props) applied to
 * MuiCheckbox to make it match the design system.
 *
 * See: https://mui.com/material-ui/api/checkbox/#css
 */ export const MuiCheckbox = {
    styleOverrides: {
        root: ({ theme })=>({
                color: theme.palette.border.prominent,
                '&:hover': {
                    backgroundColor: theme.palette.background.hover,
                    borderRadius: '4px',
                    [`&:not(.${checkboxClasses.checked}, .${checkboxClasses.indeterminate})`]: {
                        color: theme.palette.text.secondary
                    }
                },
                [`&.${checkboxClasses.disabled}`]: {
                    color: theme.palette.border.subtle
                }
            })
    }
};

//# sourceMappingURL=checkbox-overrides.js.map